import { call, put, takeLatest } from 'redux-saga/effects';

import { getSlots } from '../../services/API';
import { actionTypes, requestFailure, requestSuccess } from './actions';

function* getData(action) {
  const response = yield call(getSlots, action.payload);
  yield put(response.isOk ? requestSuccess(response.data) : requestFailure(response.error));
}

export default function* slotsSaga() {
  yield takeLatest(actionTypes.REQUEST_START, getData);
}
